export class FormMessage {
  messageID: string = '';
  messageText: string = '';
  messageType: string = '';

  public static readonly RequiredMessageID = 'a4273634-6e58-4c3e-aec8-eabb2e6d92dc';
  public static readonly Index0MessageID = 'b5384745-7f69-5d4f-bfd9-fbcc2f7e03ed';
  public static readonly NumericValidatorMessageID = '3db691ee-4932-4e09-804a-79f6f748c668';
  public static readonly PatternValidatorMessageID = '31b053f3-bc2b-4086-9e0e-f883669d3eac';
  public static readonly MinValidatorMessageID = 'f117ceec-3dc8-453d-af6f-b40fe459890c';
  public static readonly MaxValidatorMessageID = '11e04d04-9a42-4e1e-b533-f848c300ee5e';
  public static readonly DateValidatorMessageID = '97849e54-a958-467f-bf3e-38b203ff07c8';
}
